import React from "react";
import { Navigate } from "react-router-dom";
import SignUpPage from "../../pages/auth/SignUpPage";
import SignInPage from "../../pages/auth/SignInPage";
import DashboardPage from "../../pages/dashboard/DashboardPage";
import UserSettingsPage from "../../pages/UserSettingsPage";
import { ChatPage } from "../../pages/chat/ChatPage";
import HomePage from "../HomePage";
import { SignedIn, SignedOut, useAuth } from "@clerk/clerk-react";
import { MockSignedIn, MockSignedOut, mockUseAuth } from "../../lib/clerk-mock";

// Check if we're in E2E mode
const isE2EMode = import.meta.env.VITE_E2E_MODE === 'true';

// Use mocked components in E2E mode
const AuthSignedIn = isE2EMode ? MockSignedIn : SignedIn;
const AuthSignedOut = isE2EMode ? MockSignedOut : SignedOut;
const useAuthHook = isE2EMode ? mockUseAuth : useAuth;

// Loading component to show while Clerk initializes
function ClerkLoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[hsl(var(--background))]">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[hsl(var(--primary))] mx-auto"></div>
        <p className="text-sm text-[hsl(var(--muted-foreground))]">Loading...</p>
      </div>
    </div>
  );
}

export function RootRoute() {
  return <HomePage />;
}

export function SignUpRoute() {
  const { isLoaded } = useAuthHook();
  
  if (!isLoaded) {
    return <ClerkLoadingSpinner />;
  }
  
  return (
    <>
      <AuthSignedIn>
        <Navigate to="/pa/dashboard" replace />
      </AuthSignedIn>
      <AuthSignedOut>
        <SignUpPage />
      </AuthSignedOut>
    </>
  );
}

export function SignInRoute() {
  const { isLoaded } = useAuthHook();
  
  if (!isLoaded) {
    return <ClerkLoadingSpinner />;
  }
  
  return (
    <>
      <AuthSignedIn>
        <Navigate to="/pa/dashboard" replace />
      </AuthSignedIn>
      <AuthSignedOut>
        <SignInPage />
      </AuthSignedOut>
    </>
  );
}

export function DashboardRoute() {
  const { isLoaded } = useAuthHook();
  
  if (!isLoaded) {
    return <ClerkLoadingSpinner />;
  }
  
  return (
    <>
      <AuthSignedIn>
        <DashboardPage />
      </AuthSignedIn>
      <AuthSignedOut>
        <Navigate to="/pa/sign-up" replace />
      </AuthSignedOut>
    </>
  );
}

export function SettingsRoute() {
  const { isLoaded } = useAuthHook();
  
  if (!isLoaded) {
    return <ClerkLoadingSpinner />;
  }
  
  return (
    <>
      <AuthSignedIn>
        <UserSettingsPage />
      </AuthSignedIn>
      <AuthSignedOut>
        <Navigate to="/pa/sign-in" replace />
      </AuthSignedOut>
    </>
  );
}

export function ChatRoute() {
  const { isLoaded } = useAuthHook();
  
  if (!isLoaded) {
    return <ClerkLoadingSpinner />;
  }
  
  return (
    <>
      <AuthSignedIn>
        <ChatPage />
      </AuthSignedIn>
      <AuthSignedOut>
        <Navigate to="/pa/sign-in" replace />
      </AuthSignedOut>
    </>
  );
}
